import Calculator from "./Calculator";
import { useState } from "react";
import { userInputType } from "./investment";
import Result from "./Result";
import Header from "../UI/Header";
import Footer from "../UI/Footer";

export default function CalculatorPage() {
    const [userInput, setUserInput] = useState<userInputType>({
        initialInvestment: 10000,
        annualInvestment: 1200,
        expectedReturn: 6,
        duration: 10,
    });

    const inputIsValid = userInput.duration > 0;

    function handleChange(userIdentifier: string, newValue: string) {
        setUserInput(prevUserInput => {
            return {
                ...prevUserInput,
                [userIdentifier]: +newValue // + is a unary operator that converts a string to a number
            }
        })
    }

    return (
        <>
        <Header/>
            <Calculator onChange={handleChange} userInput={userInput} inputIsValid={inputIsValid}/>
            {!inputIsValid && <p className="center">Please enter a duration greater than zero.</p>}
            {inputIsValid && <Result calculationResult={userInput}/>}
        <Footer />
        </>
    );
}